/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The InlineResponse20027Occupations model module.
 * @module model/InlineResponse20027Occupations
 * @version 1.0.0
 */
export default class InlineResponse20027Occupations {
  /**
   * Constructs a new <code>InlineResponse20027Occupations</code>.
   * @alias module:model/InlineResponse20027Occupations
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20027Occupations</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20027Occupations} obj Optional instance to populate.
   * @return {module:model/InlineResponse20027Occupations} The populated <code>InlineResponse20027Occupations</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20027Occupations()

      if (data.hasOwnProperty('label')) {
        obj['label'] = ApiClient.convertToType(data['label'], 'String')
      }
      if (data.hasOwnProperty('count')) {
        obj['count'] = ApiClient.convertToType(data['count'], 'Number')
      }
    }
    return obj
  }

  /**
   * @member {String} label
   */
  label = undefined
  /**
   * @member {Number} count
   */
  count = undefined
}
